module.exports = __webpack_public_path__ + "static/react-8d859602e4edf37f8e6fbce188479840.png";